var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChannelGreyIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.035,
    height: 12,
    viewBox: "0 0 12.035 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Channels_gray",
    transform: "translate(-10081 760)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_160891",
    "data-name": "Group 160891",
    transform: "translate(10081 -760)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_160890",
    "data-name": "Group 160890"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_140092",
    "data-name": "Rectangle 140092",
    width: 12,
    height: 12,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_160827",
    "data-name": "Group 160827",
    transform: "translate(3012.13 -333.248)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2335",
    "data-name": "Path 2335",
    d: "M0,0H11.662V11.662H0Z",
    transform: "translate(7069.243 -426.526)",
    fill: "none",
    opacity: 0
  })), /*#__PURE__*/React.createElement("g", {
    id: "Channels_gray-2",
    "data-name": "Channels_gray",
    transform: "translate(10079.284 -761.639)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2331",
    "data-name": "Path 2331",
    d: "M16.24,5.62A2.62,2.62,0,1,1,13.62,3,2.62,2.62,0,0,1,16.24,5.62Z",
    transform: "translate(-3.808)",
    fill: "none",
    stroke: "#71839b",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2332",
    "data-name": "Path 2332",
    d: "M6.668,13.834A1.834,1.834,0,1,1,4.834,12,1.834,1.834,0,0,1,6.668,13.834Z",
    transform: "translate(0 -4.284)",
    fill: "none",
    stroke: "#71839b",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2333",
    "data-name": "Path 2333",
    d: "M16.62,17.31A1.31,1.31,0,1,1,15.31,16,1.31,1.31,0,0,1,16.62,17.31Z",
    transform: "translate(-5.236 -6.187)",
    fill: "none",
    stroke: "#71839b",
    strokeWidth: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChannelGreyIcon);
export default __webpack_public_path__ + "static/media/channel-grey-icon.4267fc6c732e77fc0709a976d8b688ee.svg";
export { ForwardRef as ReactComponent };